import { Box, ImageList, useMediaQuery } from "@mui/material";
import "../../styles/AboutSection/AboutSection.scss";
import ScrollSection from "./AboutUsItems";
import HorizontalList from "./horizonatallList";
import { useTranslation } from "react-i18next";

export const AboutSection = () => {
  const isMobile = useMediaQuery("(max-width:800px)");

  const { t } = useTranslation();

  const cards = [
    {
      id: "1",
      title: t("who_we_are"),
      subtitle: t("who_we_are_subtitle"),
    },
    {
      id: "2",
      title: t("mission"),
      subtitle: t("mission_subtitle"),
    },
    {
      id: "3",
      title: t("values"),
      subtitle: t("values_subtitle"),
    },
    {
      id: "4",
      title: t("vision"),
      subtitle: t("vision_subtitle"),
    },
  ];

  return (
    <section className="AboutSection" id="AboutSection">
      <Box sx={{ display: isMobile ? "block" : "flex" }}>
        <Box
          component="img"
          src={"images/chair.png"}
          alt="chair"
          sx={{
            objectFit: "cover",
            maxWidth: {
              xs: "100%",
              sm: isMobile ? "100%" : "50%",
              md: "60%",
              lg: "100%",
            },
          }}
        />
        {isMobile ? (
          <HorizontalList cards={cards} />
        ) : (
          <ScrollSection cards={cards} />
        )}
      </Box>
    </section>
  );
};
